import { useState, useEffect } from 'react';
import { Paperclip, FileText, X, Loader2 } from 'lucide-react';
import { Input } from '../ui/input';
import { savApi } from './savApi';
import { eur, errMsg } from '../invoice/api';

// Justificatifs (fichiers) et factures déjà enregistrées : rattacher une facture ne crée jamais de seconde dépense
export function SavJustifs({ files, setFiles, invoices, setInvoices }) {
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');
    const [q, setQ] = useState('');
    const [found, setFound] = useState([]);
    useEffect(() => {
        if (q.trim().length < 2) { setFound([]); return undefined; }
        const t = setTimeout(() => savApi.invoices(q).then(setFound).catch(() => setFound([])), 250);
        return () => clearTimeout(t);
    }, [q]);
    const upload = async (list) => {
        setBusy(true); setErr('');
        for (const f of Array.from(list)) {
            try { const r = await savApi.upload(f); setFiles(fs => [...fs, { id: r.id, filename: r.filename }]); } catch (e) { setErr(`${f.name} : ${errMsg(e)}`); }
        }
        setBusy(false);
    };
    return (
        <div className="space-y-2" data-testid="sav-justifs">
            <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider">Factures et justificatifs</p>
            <label className="flex items-center gap-2 rounded-lg border border-dashed border-gray-300 px-3 py-2 text-[12px] text-gray-600 cursor-pointer hover:bg-gray-50" data-testid="sav-justif-upload-label">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Paperclip className="w-4 h-4" />}Ajouter des fichiers (PDF, photo)
                <input type="file" multiple accept="application/pdf,image/*" className="hidden" onChange={e => { upload(e.target.files); e.target.value = ''; }} data-testid="sav-justif-upload" />
            </label>
            {err && <p className="text-[12px] text-red-600" data-testid="sav-justif-error">{err}</p>}
            <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Facture déjà enregistrée (n°, fournisseur)" className="h-9 text-[12px]" data-testid="sav-invoice-search" />
            {found.filter(f => !invoices.some(i => i.id === f.id)).slice(0, 6).map(f => (
                <button key={f.id} type="button" onClick={() => { setInvoices(is => [...is, f]); setQ(''); }} className="w-full text-left rounded-md border border-gray-100 px-2 py-1.5 text-[12px] hover:bg-gray-50" data-testid={`sav-invoice-option-${f.id}`}>
                    {f.fournisseur || '—'} · n° {f.numero_facture || '—'} · {eur(f.montant_ttc)} · {f.date_facture || ''}
                </button>
            ))}
            <ul className="space-y-1">
                {invoices.map(i => <Item key={i.id} label={`Facture ${i.fournisseur || ''} n° ${i.numero_facture || '—'} (${eur(i.montant_ttc)}) — déjà comptabilisée, aucune seconde dépense`} onRemove={() => setInvoices(is => is.filter(x => x.id !== i.id))} testId={`sav-invoice-${i.id}`} />)}
                {files.map(f => <Item key={f.id} label={f.filename} onRemove={() => setFiles(fs => fs.filter(x => x.id !== f.id))} testId={`sav-justif-${f.id}`} />)}
            </ul>
        </div>
    );
}

const Item = ({ label, onRemove, testId }) => (
    <li className="flex items-center gap-2 rounded-md bg-gray-50 px-2 py-1 text-[12px] text-gray-700" data-testid={testId}>
        <FileText className="w-3.5 h-3.5 shrink-0" /><span className="flex-1 break-words min-w-0">{label}</span>
        <button type="button" onClick={onRemove} aria-label="Retirer" data-testid={`${testId}-remove`}><X className="w-3.5 h-3.5 text-gray-400" /></button>
    </li>
);
